import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PythonOutlinedSvg from "@ant-design/icons-svg/es/asn/PythonOutlined";
import AntdIcon from '../components/AntdIcon';
var PythonOutlined = function PythonOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    icon: PythonOutlinedSvg
  }));
};
var RefIcon = /*#__PURE__*/React.forwardRef(PythonOutlined);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'PythonOutlined';
}
export default RefIcon;